import { Firebase } from './Firebase';

export function TableHeader() {
    return (
      <div id="Table-header">
        <p className="text-lg-start">Top 5 Best Deals ⋆</p>
      </div>
    );
  }